import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { stringToPointNumber } from "MainPages/Utils/decimal.utils";
import dayjs from "dayjs";
import {
  useFormattedUserListOption,
  useFormattedVehicleCategoryOption,
  useFormattedVehicleTypeOption,
} from "core/Operations/formattedOption/useFormattedMasterOptions";
import PropTypes from "prop-types";
import InputWarningMessage from "Components/UI/InputWarningMessage";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";

const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "Inactive", value: false },
];

const projectStatusOptions = [
  { label: "Pending", value: "Pending" },
  { label: "Processing", value: "Processing" },
  { label: "Completed", value: "Completed" },
];

const ProjectInformation = ({ userData }) => {
  const {
    watch,
    setValue,
    trigger,
    register,
    formState: { errors },
  } = useFormContext();

  const approvedByOptions = useFormattedUserListOption({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });
  // console.log("approvedByOptions", approvedByOptions);
  const index = 0;
  return (
    <>
      <div className="form-row row">
        <h4 className="header-title">Project Information</h4>
        {watch("projectCode") !== "" && (
          <div className="col-md-4 col-sg-12 mb-3">
            <Input
              name={`projectCode`}
              type="text"
              placeholder="Project Code"
              className={`form-control ${
                errors?.projectCode ? "is-invalid" : ""
              }`}
              label="Project Code"
              labelClassName="form-label"
              readOnly={true}
              required={false}
              requiredMessage="Project Code is required"
            />
          </div>
        )}

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`projectName`}
            type="text"
            placeholder="Project Name"
            className={`form-control ${
              errors?.projectName ? "is-invalid" : ""
            }`}
            label="Project Name"
            labelClassName="form-label"
            required={true}
            requiredMessage="Project Name is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`abbreviation`}
            type="text"
            placeholder="Abbreviation"
            className={`form-control ${
              errors?.abbreviation ? "is-invalid" : ""
            }`}
            label="Abbreviation Name"
            labelClassName="form-label"
            required={false}
            requiredMessage="Abbreviation Name is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`projectStartDay`}
            type="date"
            placeholder="Project Start Day"
            className={`form-control ${
              errors?.projectStartDay ? "is-invalid" : ""
            }`}
            label="Project Start Day"
            labelClassName="form-label"
            required={true}
            requiredMessage="Project Start Day is required"
            dateFormat="YYYY-MM-DD"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`projectEndDay`}
            type="date"
            placeholder="Project End Day"
            className={`form-control ${
              errors?.projectEndDay ? "is-invalid" : ""
            }`}
            label="Project End Day"
            labelClassName="form-label"
            required={false}
            requiredMessage="Project End Day is required"
            dateFormat="YYYY-MM-DD"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name={`projectStatus`}
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors?.projectStatus ? "is-invalid" : ""
            }`}
            label="Project Status"
            labelClassName="form-label"
            optionData={projectStatusOptions}
            required={false}
            requiredMessage="Project Status is required"
            onChange={(selectedOption) => {
              setValue("projectStatus", selectedOption);
              trigger("projectStatus");
            }}
            defaultValue={watch("projectStatus")}
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name={`approvedBy`}
            type="commonSelect"
            placeholder="Select Approved By"
            className={`form-control select ${
              errors?.approvedBy ? "is-invalid" : ""
            }`}
            label="Approved By"
            labelClassName="form-label"
            optionData={approvedByOptions}
            required={false}
            requiredMessage="Approved By is required"
            onChange={(selectedOption) => {
              setValue("approvedBy", selectedOption);
              trigger("approvedBy");
            }}
            defaultValue={watch("approvedBy")}
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`remarks`}
            type="text"
            placeholder="Remarks"
            className={`form-control ${errors?.remarks ? "is-invalid" : ""}`}
            label="Remarks"
            labelClassName="form-label"
            required={true}
            requiredMessage="Remarks is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`isActive`}
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors?.isActive ? "is-invalid" : ""
            }`}
            label="Active Status"
            labelClassName="form-label"
            optionData={isStatusOption}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue(`isActive`, selectedOption?.value);
              trigger(`isActive`);
            }}
            defaultValue={watch(`isActive`)}
          />
        </div>
      </div>

      <div className="form-row row">
        <h4 className="header-title">Incharge Details</h4>
        <div className="col-md-12 col-sg-12 mb-3">
          <Input
            name={`selectedEmployees`}
            type="commonSelect"
            placeholder="E"
            className={`form-control ${
              errors?.selectedEmployees ? "is-invalid" : ""
            }`}
            optionData={employeeOptions}
            // onSelect={(selectedOption) => {
            //   setValue("selectedEmployees", selectedOption);
            //   trigger("selectedEmployees");
            // }}
            onChange={(selectedOptions) => {
              console.log(selectedOptions);
              setValue(
                "selectedEmployees",
                Array.isArray(selectedOptions)
                  ? selectedOptions.map((option) => option)
                  : []
              );
            }}
            defaultValue={watch("selectedEmployees")}
            mode="multiple"
            label="Employees"
            labelClassName="form-label"
            required={false}
            requiredMessage="Employees is required"
            allowClear
            showSearch
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </div>

      <div className="form-row row">
        <h4 className="header-title">Project Description</h4>
        <div className="col-md-12 col-sg-12 col-12 mb-3">
          <div className="form-floating">
            <textarea
              {...register(`projectDescription`, { required: true })}
              placeholder="Project Description"
              className={`form-control ${
                errors?.projectDescription ? "is-invalid" : ""
              }`}
              rows={10}
              style={{ height: "200px" }}
              defaultValue={watch("projectDescription")}
            ></textarea>
            <label htmlFor={`projectDescription`} className="form-label">
              Project Description
            </label>
            {errors?.projectDescription && (
              <div className="invalid-feedback">
                {errors?.projectDescription?.message}
              </div>
            )}
          </div>
        </div>
      </div>
      <InputWarningMessage
        message="*All mandatory fields to be entered to Save the record."
        type="danger"
      />
    </>
  );
};
ProjectInformation.propTypes = {
  userData: PropTypes.any.isRequired,
};
export default React.memo(ProjectInformation);
